import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

const UiVirtualScroll = ({
  offset = 0,
  buffer,
  limit,
  rowHeight,
  height,
  total,
  onPrevCallback,
  onNextCallback,
  children,
  isLoading,
  setIsLoading
}) => {
  // create overlay reference to trigger the change scroll position
  const overlayRef = useRef(null);

  // create two cursors of lower and upper boundary of cached items indices
  // initial upper boundary index is 0
  const [upperBoundary, setUpperBoundary] = useState(offset + 20);
  // initial lower boundary index is 300-1 = 299
  const [lowerBoundary, setLowerBoundary] = useState(buffer);
  // const [isLoading, setIsLoading] = useState(false);
  // current scroll position starting with 0
  const [currentScrollTopPosition, setCurrentScrollTopPosition] = useState(0);

  const handleScroll = async (target) => {
    // ignore the scroll if data is loading
    if (isLoading) {
      return;
    }

    // get the current position of the scroll
    const scrollTop = Math.round(target.scrollTop);
    // extracting the client height and scroll height to calculate the top scroll maximum position
    // where is highest scroll position is scrollHeight = clientHeight + scrollTop
    const clientHeight = Math.round(target.clientHeight);
    const scrollHeight = Math.round(target.scrollHeight);

    // defining if we currently scrolling up or down
    const isUp = scrollTop < currentScrollTopPosition;

    if (upperBoundary > 0 && isUp && scrollTop === 0) {
      // setIsLoading(true);
      await onPrevCallback(upperBoundary - limit);
      // update boundaries to move indices - limit
      setUpperBoundary(upperBoundary - limit);
      setLowerBoundary(lowerBoundary - limit);

      // move scroll position to 1 limit height
      if (overlayRef !== null) {
        const scrollPos = limit * rowHeight;
        overlayRef.current.scrollTo(0, scrollPos + rowHeight);
      }
      // setIsLoading(false);
    } else if (total > lowerBoundary && !isUp && scrollTop + clientHeight >= scrollHeight) {
      // setIsLoading(true);
      await onNextCallback(lowerBoundary);
      // update boundaries to move indices + limit
      setUpperBoundary(upperBoundary + limit);
      setLowerBoundary(lowerBoundary + limit);
      if (overlayRef !== null) {
        const scrollPos = limit * rowHeight;
        // move scroll position to 2 limits height
        console.log(scrollPos);
        overlayRef.current.scrollTo(0, scrollPos * 2 + clientHeight);
      }
      setIsLoading(false);
    }
    // update the current cursor position
    setCurrentScrollTopPosition(scrollTop);
  };

  return (
    <div style={{position: 'relative' }}>
      <div
        className='currentlist-table'
        ref={overlayRef}
        style={{ height, overflowY: 'auto'}}
        onScroll={(e) => handleScroll(e.target)}>
        {children}
        {isLoading && (
          <div className='scroll-spinner mt-3 d-flex align-item-center justify-content-center'>
            <FontAwesomeIcon icon={faSpinner} spin  /><span className='ms-2'>Load More</span>
          </div>
        )}
      </div>
    </div>
  );
};

UiVirtualScroll.propTypes = {
  offset: PropTypes.number,
  buffer: PropTypes.number,
  limit: PropTypes.number,
  rowHeight: PropTypes.number,
  height: PropTypes.string,
  total: PropTypes.number,
  onPrevCallback: PropTypes.func,
  onNextCallback: PropTypes.func,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  setIsLoading: PropTypes.func,
};

export default UiVirtualScroll;
